<template>
<div class="details-section grouping-details-section">
  <ul class="details-list">
    <li v-if="grouping.generation" class="detail">
      <span class="elr-bold">Generation:</span>
      <router-link :to="`/generation/${grouping.generation.slug}`">{{grouping.generation.name}}</router-link>
    </li>
    <li v-if="grouping.brand" class="detail">
      <span class="elr-bold">Brand:</span>
      <router-link :to="`/brand/${grouping.brand.slug}`">{{grouping.brand.name}}</router-link>
    </li>
    <li v-if="grouping.release" class="detail">
      <span class="elr-bold">Release Type:</span>
      <router-link :to="`/release/${grouping.release.slug}`">{{grouping.release.name}}</router-link>
    </li>
    <li v-if="grouping.year" class="detail">
      <span class="elr-bold">Year:</span>
      <router-link :to="`/year/${grouping.year.slug}`">{{grouping.year.year_made}}</router-link>
    </li>
    <li v-if="grouping.origin" class="detail">
      <span class="elr-bold">Origin:</span>
      <router-link :to="`/origin/${grouping.origin.slug}`">{{grouping.origin.name}}</router-link>
    </li>
    <li v-if="grouping.manufacturer" class="detail">
      <span class="elr-bold">Manufacturer:</span>
      <router-link :to="`/manufacturer/${grouping.manufacturer.slug}`">{{grouping.manufacturer.name}}</router-link>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  name: 'GroupingDetails',
  props: {
    grouping: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../assets/sass/config';

.detail span {
  padding-right: 5px;
}

.grouping-details-section {
  border-top: 1px solid $accent-color;
  border-bottom: 1px solid $accent-color;
}
</style>
